import React from 'react';
import EditorDashboardWrapper from '../../../layout/wrapper/EditorDashboardWrapper';
import styles from '../../../styles/pages/user/qcagentdashboard/qc-message.module.scss'
import { Box, List, ListItem , Select, MenuItem, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography} from '@mui/material';
import view_icon from '../../../public/assets/images/eye_icon.svg'
import key_icon from '../../../public/assets/images/lock_icon.svg'
import LeftArrow from '../../../ui/Icons/LeftArrow';
import RightArrow from '../../../ui/Icons/RightArrow';
import PerfectScrollbar from "react-perfect-scrollbar"
import { useState } from 'react';
import MessageIcon from '../../../ui/Icons/MessageIcon';
import { Link } from 'react-router-dom';
import QcDashboardWrapper from '../../../layout/wrapper/QcDashboradWrapper';





const SelectItem = [
    {
        name: "Message Status",
    },
    {
        name: "Option1",
    },
    {
        name: "Option2",
    }
]

const tableHead = [
    {
        name: "VSID"
    },
    {
        name: "Sender"
    },
    {
        name: "Recipient"
    },
    {
        name: "Message"
    },
    {
        name: "Creation Date"
    },
    {
        name: "Status"
    },
    {
        name: "View"
    }
]

const tableBody = [
    {
        id: "#15465",
        name: "Sender Name",
        designation: "Copywriter",
        recipentName: "Me, Myself & I",
        recipentDesignation: "QC Agent",
        message: "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
        date: <>January 16, 2023 <br/> at 07:53 AM UTC</>,
        statusQuery: false,
    },
    {
        id: "#6589",
        name: "Me, Myself & I",
        designation: "QC Agent",
        recipentName: "Recipient Name",
        recipentDesignation: "Admin",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br/> at 10:22 PM UTC</>,
        statusQuery: true,
    },
    {
        id: "#15876",
        name: "Me, Myself & I",
        designation: "QC Agent",
        recipentName: "Recipient Name",
        recipentDesignation: "Manager",
        message: "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
        date: <>January 01, 2023 <br/> at 07:22 PM UTC</>,
        statusQuery: true,
    }

]



const tableHeadArchieve = [
    {
        name: "VSID"
    },
    {
        name: "Sender"
    },
    {
        name: "Recipient"
    },
    {
        name: "Message"
    },
    {
        name: "Creation Date"
    },
    {
        name: "Resolved On"
    },
    {
        name: "View"
    }
]

const tableBodyArchieve = [
    {
        id: "#15465",
        name: "Sender Name",
        designation: "Copywriter",
        recipentName: "Me, Myself & I",
        recipentDesignation: "QC Agent",
        message: "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
        date: <>January 16, 2023 <br/> at 07:53 AM UTC</>,
        resolveDate: <>January 16, 2023 <br/> at 07:53 AM UTC</>,
    },

    {
        id: "#6589",
        name: "Me, Myself & I",
        designation: "QC Agent",
        recipentName: "Recipient Name",
        recipentDesignation: "Admin",
        message: "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
        date: <>January 14, 2023 <br/> at 10:22 PM UTC</>,
        resolveDate: <>January 16, 2023 <br/> at 07:53 AM UTC</>,
    },

    {
        id: "#15876",
        name: "Me, Myself & I",
        designation: "QC Agent",
        recipentName: "Recipient Name",
        recipentDesignation: "QC Agent",
        message: "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
        date: <>January 01, 2023 <br/> at 07:22 PM UTC</>,
        resolveDate: <>January 16, 2023 <br/> at 07:53 AM UTC</>,
    },


]

function QcMessage() {
    const [age, setAge] = React.useState('0');
    const [status, setStatus] = React.useState("");

    const handleChange1 = (event) => {
        setStatus(event.target.value);
    };
    const handleChange2 = (event) => {
        setAge(event.target.value);
      };

      const [Archive,ArchiveUpdate] = useState(false);

      const handleClicked = () =>{
        ArchiveUpdate(!Archive);
      }

      const [messageShow,messageHide] = useState(true)

    return (
        <>
           <QcDashboardWrapper>
            {
                messageShow ?
                <Box className={styles.message_status_wrapper}>
                    <Box className={styles.message_status_topwrp}>
                        <List>
                            <ListItem>
                                <Box className={styles.status_messages_select}>
                                <Select
                        value={status}
                        onChange={handleChange1}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    boxShadow:
                                        "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                    borderRadius: "7px",
                                    marginTop: "5px",

                                    "& .MuiMenuItem-root": {
                                        padding: 0,
                                        fontSize: "11px",
                                        fontWeight: "500",
                                        color: "#525050",
                                        lineHeight: "1",
                                        "&:hover": {
                                            backgroundColor: "#ffffff",
                                            color: "#111ae9",
                                        },
                                        "&:not(:last-child)": {
                                            marginBottom: "10px",
                                        },
                                        "&:first-child": {
                                            display: "none"
                                        },
                                    },
                                    "& .Mui-selected": {
                                        background: "#fff !important",
                                    },

                                    "& .MuiList-root": {
                                        padding: "20px 14px",
                                        minWidth: "134px",
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem value="">Message Status</MenuItem>
                        <MenuItem value='asd'>Need your reply</MenuItem>
                        <MenuItem value='2'>Pending</MenuItem>
                        <MenuItem value='1'>Resolved</MenuItem>
                    </Select>
                                </Box>
                            </ListItem>

                            <ListItem>
                                <Box className={styles.creation_date}>
                                    <Button>
                                        Creation Date
                                        <i><img src={key_icon} alt=''/></i>
                                    </Button>
                                </Box>
                            </ListItem>

                            <ListItem>
                                <Button className={Archive ? `${styles.archievr_btns} ${styles.active}` : `${styles.archievr_btns}`} onClick={handleClicked}>Archive</Button>
                            </ListItem>
                        </List>
                    </Box>
                    
                    
                        <Box className={styles.message_status_btmwrp}>
                            {
                                Archive ?
                                <PerfectScrollbar className={styles.perfect_scroll_message}>
                                    <TableContainer>
                                        <Table aria-label="customized table" className={styles.new_table_customised}>
                                            <TableHead>
                                                <TableRow>
                                                    
                                                        {
                                                            tableHeadArchieve.map((item,index)=>(
                                                                <TableCell component="th">  
                                                                    {item?.name}
                                                                </TableCell>
                                                            ))
                                                        }
                                                    
                                                </TableRow>
                                            </TableHead>   

                                            <TableBody>      
                                                    {
                                                        tableBodyArchieve.map((item,index)=>(
                                                            <TableRow>
                                                                <TableCell component="td" scope="row" className={styles.id_table}>
                                                                    <Box className={styles.table_id_captns}>
                                                                         <Link to="/">{item?.id}</Link>

                                                                        <Typography variant='caption' className={styles.tooltips_spn}>Open Video Page</Typography>
                                                                    </Box>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.sender_table}>
                                                                    {item?.name}
                                                                    <Typography variant='caption' className={styles.design_profile}>
                                                                        {item?.designation}
                                                                    </Typography>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.recipant_nm_table}>
                                                                    {item?.recipentName}
                                                                    <Typography variant='caption' className={styles.design_profile}>
                                                                        {item?.recipentDesignation}
                                                                    </Typography>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.messages_table}>
                                                                    {item?.message}
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.creation_date_table}>
                                                                    {item?.date}
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.resolve_table_date}>
                                                                    {item?.resolveDate}
                                                                </TableCell>
                                                                
                                                                <TableCell component="td" scope="row" className={styles.view_sec_table}>
                                                                    <Box className={styles.eye_icon_tooltip}>
                                                                        <Button className={styles.eye_icon_sec}><img src={view_icon} alt=''/></Button>
                                                                        <Typography variant='caption' className={styles.tooltips_spn2}>Open Message</Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                
                                                            </TableRow>
                                                        ))
                                                    } 
                                            </TableBody>           

                                        </Table>
                                    </TableContainer>
                                </PerfectScrollbar>
                                :
                                <PerfectScrollbar className={styles.perfect_scroll_message}>
                                    <TableContainer>
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    
                                                        {
                                                            tableHead.map((item,index)=>(
                                                                <TableCell component="th">  
                                                                    {item?.name}
                                                                </TableCell>
                                                            ))
                                                        }
                                                    
                                                </TableRow>
                                            </TableHead>   

                                            <TableBody>      
                                                    {
                                                        tableBody.map((item,index)=>(
                                                            <TableRow>
                                                                <TableCell component="td" scope="row" className={styles.id_table}>
                                                                    <Box className={styles.table_id_captns}>
                                                                         <Link to="/">{item?.id}</Link>

                                                                        <Typography variant='caption' className={styles.tooltips_spn}>Open Video Page</Typography>
                                                                    </Box>
                                                                    
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.sender_table}>
                                                                    {item?.name}
                                                                    <Typography variant='caption' className={styles.design_profile}>
                                                                        {item?.designation}
                                                                    </Typography>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.recipant_nm_table}>
                                                                    {item?.recipentName}
                                                                    <Typography variant='caption' className={styles.design_profile}>
                                                                        {item?.recipentDesignation}
                                                                    </Typography>
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.messages_table}>
                                                                    {item?.message}
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.creation_date_table}>
                                                                    {item?.date}
                                                                </TableCell>

                                                                <TableCell component="td" scope="row" className={styles.status_table}>
                                                                    {
                                                                        item?.statusQuery?
                                                                        <Typography variant='caption' className={`${styles.quer_sec_btns} ${styles.resolved}`}>Resolved</Typography>
                                                                        :
                                                                        <Button className={styles.quer_sec_btns}>Need your reply</Button>
                                                                    }
                                                                </TableCell>
                                                                
                                                                <TableCell component="td" scope="row" className={styles.view_sec_table}>
                                                                    <Box className={styles.eye_icon_tooltip}>
                                                                        <Button className={styles.eye_icon_sec}><img src={view_icon} alt=''/></Button>
                                                                        <Typography variant='caption' className={styles.tooltips_spn2}>Open Message</Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                
                                                            </TableRow>
                                                        ))
                                                    } 
                                            </TableBody>
                                        </Table>           
                                    </TableContainer>
                                </PerfectScrollbar>
                            }
                            
                        </Box>
                   

                    <Box className={styles.nextprev_btn}>
                        <List>
                            <ListItem>
                                <Button className={`${styles.prev_btn} ${styles.cmn_pagination_btn}`}>
                                    <Typography variant='caption'><i><LeftArrow/></i> Prev</Typography>
                                </Button>
                            </ListItem>

                            <ListItem>
                                <Button className={`${styles.nxt_btn} ${styles.cmn_pagination_btn}`}>
                                    <Typography variant='caption'><i><RightArrow/></i> Next</Typography>
                                </Button>
                            </ListItem>
                        </List>
                    </Box>

                </Box>
                :
                <Box className={styles.team_message_boxes}>
                    <i className={styles.icon}><MessageIcon/></i>
                    <Typography variant='body1'>You don’t have any team messages at the moment.</Typography>
                </Box>
            }
                

                
           </QcDashboardWrapper>
        </>
    );
}

export default QcMessage;